import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import SummaryApi from "../../../common";
import "./loader.css";

const MatadarList = () => {
  const [wards, setWards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userName, setUserName] = useState("");
  const [userPhoto, setUserPhoto] = useState("");
  const navigate = useNavigate();
  const [pad, setPad] = useState("");

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("umedwarUser"));
    if (storedUser) {
      setUserName(storedUser.fullName);
      setUserPhoto(storedUser.pakshaPhoto);
      setPad(storedUser.pad || "");
      console.log("data", storedUser.allowedColumns);
    }

    // ✅ Fetch Matdar data
    fetch(SummaryApi.GetMatdar.url)
      .then((res) => res.json())
      .then((data) => {
        let formattedData = [];

        if (Array.isArray(data)) {
          formattedData = data;
        } else if (typeof data === "object") {
          Object.keys(data).forEach((wardKey) => {
            data[wardKey].forEach((item) => {
              formattedData.push({ ...item, wardNumber: wardKey });
            });
          });
        }

        const uniqueWards = [
          ...new Set(formattedData.map((item) => Number(item.wardNumber))),
        ].sort((a, b) => a - b);

        setWards(uniqueWards);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching Matdar list:", err);
        setLoading(false);
      });
  }, []);

  if (loading)
    return (
      <section className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-blue-50 to-blue-100">
        <div className="book">
          <div className="book__pg-shadow"></div>
          <div className="book__pg"></div>
          <div className="book__pg book__pg--2"></div>
          <div className="book__pg book__pg--3"></div>
          <div className="book__pg book__pg--4"></div>
          <div className="book__pg book__pg--5"></div>
        </div>

        <p className="mt-8 text-blue-700 text-lg font-semibold animate-pulse text-center">
           🗳️ मतदारांची गणना सुरू आहे... कृपया थोडा वेळ थांबा!
        </p>
      </section>
    );

  if (!userName) {
    return (
      <div className="p-6 text-center mt-20">
        <h1 className="text-2xl font-bold text-red-600 mb-4">
          Access Restricted
        </h1>
        <p className="text-lg text-gray-700">
          You need to purchase a subscription to access this page.
        </p>
        <p className="text-blue-700 font-semibold mt-2">Contact: 9309140606</p>
        <Link
          to="/"
          className="inline-block mt-6 bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300"
        >
          ← Go Back
        </Link>
      </div>
    );
  }

  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-center mb-6 text-center sm:text-left">
        {/* Logo */}
        <img
          src="/ShivayTech.png"
          alt="Paksha"
          className="w-30 h-14 object-cover shadow-md mx-auto sm:mx-0"
        />

        {/* Title */}
        <h1 className="text-xl sm:text-2xl font-bold mt-2 sm:mt-0 flex-1 text-center">
          मतदार यादी (Ward List)
        </h1>

        {/* Username — hidden on mobile */}
        {userName && (
          <p className="hidden sm:block text-blue-700 font-semibold ml-auto">
            Logged in as: {userName}
          </p>
        )}
      </div>

      {pad === "ADMIN" && (
        <div className="flex justify-end pb-10">
          <button
            onClick={() => navigate("/dashboard/umedwar-accounts")}
            className="bg-orange-600 hover:bg-orange-700 text-white font-semibold py-2 px-4 rounded-lg shadow-md transition duration-200"
          >
            Manage Your Accounts
          </button>
        </div>
      )}

      {/* Ward Cards */}
      {wards.length === 0 ? (
        <p className="text-center text-gray-600">No wards found.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
          {wards.map((ward) => (
            <div
              key={ward}
              onClick={() =>
                navigate(`/matdar-dashboard/ward-wise-list/${ward}`)
              }
              className="cursor-pointer bg-blue-600 text-white text-center p-6 sm:p-8 rounded-xl shadow-lg hover:bg-blue-700 transition-all duration-300"
            >
              <h2 className="text-lg sm:text-xl font-semibold">
                वार्ड क्रमांक: {ward}
              </h2>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MatadarList;
